import { Model } from "@ofqual/portal-core/core/types";
import { injectHeaders } from "@ofqual/portal-core/core/utils/listHelpers";

export const processConditions = (data: Model[]) => {
  const sortedData = data
    .map((item) => ({
      id: item.id,
      label: `${item.code}: ${item.description}`,
      group: item.conditionCategory,
      active: item.active
    }))
    .sort((a, b) => {
      if (a.group > b.group) {
        return 1;
      } else if (a.group < b.group) {
        return -1;
      }

      if (a.id > b.id) {
        return 1;
      } else if (a.id < b.id) {
        return -1;
      }
      return 0;
    });
  return sortedData;
  //return injectHeaders(sortedData, (item) => item.group);
};